<template>
  <div class="yisu-admin">
    <!-- 头部 -->
    <div class="yisu-admin-header">

      <div class="yisu-admin-nav">
        <div class="user-box">
          <span>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-Sidenav_wode"></use>
            </svg>
          </span>
          <div class="usermenu"></div>
        </div>

        <div class="logo">
          <img :src="logo" />
          <!-- <span>YiSuCloud</span> -->
          <span>{{ $t("index.logo") }}</span>
        </div>
        <div class="menubox" @click="showmenu = !showmenu">
          <span v-if="showmenu==false">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-zhankai"></use>
            </svg>

          </span>
           <span v-else>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-guanbi"></use>
            </svg>
          </span>
        </div>
        <div class="menubox-list" v-if="showmenu==true">
          <ul>
            <template v-for="menuItems in siderRouter">
              <li
                v-for="routerItems in menuItems.menulist"
                :key="routerItems.title"
                :class="{ active: selected == routerItems.path }"
                @click="tabck(routerItems.path)"
              >
                <i class="side-icon">
                  <svg class="icon" aria-hidden="true">
                    <use v-bind:xlink:href="routerItems.icon"></use>
                  </svg>
                </i>

                <span>{{ routerItems.title }}</span>

              </li>
            </template>
          </ul>
        </div>
      </div>


      <div class="admin-logo">
        <a :href="wwwUrl"><img :src="logo" /><span>{{ $t("overview.logo") }}</span></a>
      </div>
      <div class="admin-header-tool">
        <div class="header-tool-massage">
          <span class="new-tips"></span>
          <el-carousel direction="vertical" height="20px" :autoplay="true">
            <el-carousel-item v-for="(item, index) in notice" :key="index">
              <h3 class="medium" v-if="item.link">
                <a :href="item.link" target="_blank">{{ item.message }}</a>
              </h3>
              <h3 class="medium" v-else>
                {{ item.message }}
              </h3>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="header-tool-item">

           <div class="language-box">
            <el-select
              style="min-width: 80px"
              v-model="language"
              placeholder=""
              @change="langSelect"
            >
              <el-option value="en" label="English"></el-option>
              <el-option value="zh" label="简体中文"></el-option>
            </el-select>
          </div>

          <el-popover
            placement="bottom"
            :title="$t('common.topBar.accountBalance')"
            width="300"
            trigger="hover"
          >
            <div class="account-wrap">
              <div class="balance-action">
                <div class="balance-box">${{ balance }}</div>
                <el-button type="primary" class="recharge-btn" @click="rechargeItem()">
                  {{ $t('common.topBar.addFunds') }}
                </el-button>
              </div>
              <div class="catalog-list">
                <ul>
                  <li @click="goToBillingHistory()">{{ $t('common.topBar.billingHistory') }}</li>
                  <li @click="goToOrders()">{{ $t('common.topBar.orders') }}</li>
                </ul>
              </div>
            </div>
            <div slot="reference">
              <span class="money-icon">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-meiyuan"></use>
                </svg>
              </span>
            </div>

          </el-popover>
          <div class="userimg" @click="gotoUserInfo" >
            <svg class="icon" aria-hidden="true">
              <use :xlink:href="`#icon-Sidenav_wode`"></use>
            </svg>
          </div>
          <!-- <img class="userimg" @click="gotoUserInfo" :src="userImg" /> -->
          <el-menu class="el-menu-demo" mode="horizontal">
            <el-submenu index="1" @select="handleSelect">
              <template slot="title"> {{ nickname }} </template>
              <el-menu-item index="1-1">{{ $t('common.topBar.accountId') }}: {{ username }}</el-menu-item>
              <el-menu-item index="1-2" @click="logout()">{{ $t('common.topBar.logout') }}</el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </div>
    </div>

    <div class="admin-main">
      <div class="yisu-admin-side">
        <div class="menu-box side-scroll">
          <div
            class="menu-side-itme"
            v-for="(menuItem, menuIndex) in siderRouter"
            :key="menuIndex"
          >
            <div class="menu-title">{{ menuItem.menutitle }}</div>
            <ul class="side-menu">
              <li
                v-for="(routerItem, routerIndex) in menuItem.menulist"
                :key="routerIndex"
                :class="{active:selected == routerItem.path}"
              >
                <div class="side-item"  @click="tabck(routerItem.path)">
                  <i class="side-icon">
                    <svg class="icon" aria-hidden="true">
                      <use v-bind:xlink:href="routerItem.icon"></use>
                    </svg>
                  </i>
                  <span>{{ routerItem.title }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

       <Recharge ref="rechargeModal"/>
      <div class="yisu-admin-body">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import Recharge from "@/components/user/Recharge";
import Fingerprint2 from 'fingerprintjs2';
export default {
  data() {
    return {
      language:'',
      showmenu:false,
      wwwUrl: process.env.WWW_URL,
      logo: require("@/assets/images/logo.png"),
      userImg: require("@/assets/images/user.png"),
      email: '',
      nickname: '',
      username: '',
      balance: 0,
      notice: [],
      selected: "/overview",
      siderRouter: [
        {
          menutitle: "",
          menulist: [
            {
              path: "/overview",
              title: this.$t("menu.overview"),
              icon: "#icon-Sidenav_gailan",
            },
          ],
        },
        {
          menutitle: this.$t("menu.products"),
          menulist: [
            {
              path: "/server",
              title: this.$t("menu.server"),
              icon: "#icon-Sidenav_fuwuqi",
            },
             {
              path: "/lightserver",
              title: this.$t("menu.lightServer"),
              icon: "#icon-Sidenav_swas",
            },
            {
              path: "/baremetal",
              title: this.$t("menu.baremetal"),
              icon: "#icon-Sidenav_luojinshu",
            },
            {
              path: "/database",
              title: this.$t("menu.mysql"),
              icon: "#icon-Sidenav_shujuku",
            },
            {
              path: "/slb",
              title: this.$t("menu.elb"),
              icon: "#icon-Sidenav_fuzaijunheng",
            },
            {
              path: "/ssl",
              title: this.$t("menu.ssl"),
              icon: "#icon-Sidenav_ssl",
            },
            {
              path: "/ip",
              title: this.$t("menu.ip"),
              icon: "#icon-Sidenav_gaofangIP",
            },
          ],
        },
        {
          menutitle: this.$t("menu.account"),
          menulist: [
            {
              path: "/billing",
              title: this.$t("menu.billing"),
              icon: "#icon-Sidenav_qianbao",
            },
            {
              path: "/user",
              title: this.$t("menu.profile"),
              icon: "#icon-Sidenav_wode",
            },
            {
              path: "/referral",
              title: this.$t("menu.referral"),
              icon: "#icon-Sidenav_referrer",
            },
            {
              path: "/help",
              title: this.$t("menu.help"),
              icon: "#icon-Sidenav_wendang",
            },
          ],
        },
      ],
    };
  },
  components: {
    Recharge,
  },
  watch: {
    $route: {
      handler(val, oldval) {
        this.selected = val.matched[0].path;
        if(process.env.NODE_ENV == 'production') {
          let referrer = '';
          if (oldval) {
            referrer = window.location.protocol+'//'+window.location.host+oldval.fullPath;
          }
          this.submitPageVisitData(window.location.href, referrer);
        }
        this.cookieLang();
        this.getCurrencyInfo();

      },
      immediate: true,
      deep: true,
    },
  },
  created () {
    //在页面加载时读取sessionStorage里的状态信息,然后删除sessionStorage
    if (sessionStorage.getItem("store") ) {
      this.$store.replaceState(Object.assign({}, this.$store.state,JSON.parse(sessionStorage.getItem("store"))))
      sessionStorage.removeItem("store")
    }

    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload",()=>{
      sessionStorage.setItem("store",JSON.stringify(this.$store.state))
    })
  },
  mounted() {
    this.language = this.$i18n.locale;
    this.getUserInfo();
    this.getNotice();
    this.username = this.$util.getCookie('intl_username');
  },
  methods: {
    langSelect(e) {
      this.$util.setCookie("locale", e);
      location.reload();
    },
    cookieLang(){
      let newlang = this.$util.getCookie("locale");
      if(this.language != '' && newlang !== this.language){
        this.language = this.$i18n.locale = newlang;
        window.location.reload();
      }
    },
    rechargeItem(){
      this.$refs.rechargeModal.getPayments();
      this.$refs.rechargeModal.showChange();
    },
    handleSelect(key, keyPath) {

    },
    tabck(val) {
      if (!val) return;
      if (val == '/') return;
      if (val == '/help') {
        window.open(process.env.WWW_URL+'/help/');
        return;
      }
      this.showmenu = false;
      this.selected = val;
      this.$router.push({ path: `${this.selected}` });
    },
    logout() {
      this.$http
        .post("/home/user/logout", {})
        .then((response) => {
          if (response.data.code !== 0) {
            this.$message.error(response.data.message)
            return false
          } else {
            this.$message({
              message: this.$t('common.message.logoutSuccess'),
              type: "success",
            });
            setTimeout(function () {
              window.location.href = process.env.LOGIN_URL;
            }, 1000);
          }
        })
        .catch((err) => {
          this.$util.handleErr(err);;
        });
    },
    getUserInfo() {
      this.$http
        .post("/home/user/getUserInfo", {})
        .then((response) => {
          let res = response.data.data;
          if (response.data.code !== 0) {
            this.$message.error(response.data.message)
            return false
          }
          this.balance = res.balance;
          this.nickname = res.nickname;
          this.email = res.email;
          this.$store.commit('set_balancePay', res.balance_pay)
        })
        .catch((err) => {
          this.$util.handleErr(err);;
        });
    },
    getNotice() {
      this.$http
        .post("/home/notice", {})
        .then((response) => {
          let res = response.data.data;
          if (response.data.code !== 0) {
            this.$message.error(response.data.message)
            return false
          }
          this.notice = res;
        })
        .catch((err) => {
          this.$util.handleErr(err);;
        });
    },
    goToBillingHistory() {
      this.$router.push({
        path: "/billing/index",
        query: {
          type: 'history',
        },
      });
    },
    gotoUserInfo() {
      this.$router.push({
        path: "/user/index/userinfo",
      });
    },
    goToOrders() {
      this.$router.push({
        path: "/billing/index",
        query: {
          type: 'order',
        },
      });
    },
    //获取货币信息
    getCurrencyInfo() {
      let self = this;
      this.$http
        .get("/general/currency/info")
        .then((response) => {
          let res = response.data.data;
          if (response.data.code !== 0) {
            this.$message.error(response.data.message)
            return false
          }
          this.$store.commit('set_currency', res.currentCurrencyName);
          this.$util.setCookie('currency', res.currentCurrencyName);
          this.$util.setCookie('currencyRate', res.currencyRate);
        })
        .catch((err) => {
          this.$util.handleErr(err);;
        });
    },
    submitPageVisitData(url, referrer) {
      let self = this;
      var YISUUID = this.$util.getCookie('YISUUID');
      if (YISUUID) {
        self.submitPageVisitDataRequest(url, referrer, YISUUID);
      } else {
        var fingerOptions = {excludes: {userAgent: true, enumerateDevices: true}};
        if (window.requestIdleCallback) {
          Fingerprint2.get(fingerOptions, function (components) {
            var values = components.map(function (component) { return component.value })
            YISUUID = Fingerprint2.x64hash128(values.join(''), 31);
            self.submitPageVisitDataRequest(url, referrer, YISUUID);
          })
        } else {
          setTimeout(function () {
            Fingerprint2.get(fingerOptions, function (components) {
              var values = components.map(function (component) { return component.value })
              YISUUID = Fingerprint2.x64hash128(values.join(''), 31);
              self.submitPageVisitDataRequest(url, referrer, YISUUID);
            })
          }, 500);
        }
      }
    },
    submitPageVisitDataRequest(url, referrer, YISUUID) {
      this.$http
        .post("/track/visitEvent",
          {url: url, referrer: referrer, murmur: YISUUID})
        .then((response) => {

        })
        .catch((err) => {
          this.$util.handleErr(err);
        });
    }
  },
};
</script>

<style scoped lang="scss">
/********后台********/

.yisu-admin {
}
.el-dropdown {
  color: #293142;
}

.el-menu.el-menu--horizontal {
  border: none;
}

.el-carousel--vertical {
  // min-width: 300px;
  width: 100%;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 20px;
  margin: 0;
  padding-left: 8px;
  padding-right: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}

.yisu-admin-header {
  width: 100%;
  height: 56px;
  box-shadow: 0px 1px 2px 0px rgba(200, 200, 204, 0.2);
  display: flex;

  .admin-logo {
    width: 210px;
    height: 56px;
    flex-shrink: 0;
    background-color: #0f1e33;
    box-shadow: 1px 2px 2px 0 rgb(0 0 0 / 5%);
    display: flex;
    padding-left: 30px;
    align-items: center;

    img {
      width: 22px;
      height: 17px;
      margin-right: 5px;
    }

    span {
      font-size: 14px;
      color: #fff;
    }
  }
}

.admin-header-tool {
  flex: 1;
  padding: 0 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .header-tool-item {
    height: 56px;
    display: flex;
    align-items: center;
    .userimg {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      margin: 0 10px;
      cursor: pointer;
      svg {
        width: 16px;
        height: 16px;
        font-size: 16px;
        vertical-align: top;
        fill: #909399;
      }
    }
  }
  .header-tool-massage {
    // min-width: 300px;
    flex: 1 0;
    height: 20px;
    overflow: hidden;
    display: flex;
    .new-tips {
      font-size: 14px;
      font-weight: 500;
      color: #3377ff;
      line-height: 20px;
    }
  }
}

.admin-main {
  width: 100%;
  height: calc(100vh - 60px);
  display: flex;

  .yisu-admin-side {
    flex-shrink: 0;
    width: 210px;
    overflow-x: hidden;
    min-height: calc(100vh - 60px);
    z-index: 102;
    background: #0f1e33;
    .side-scroll {
      width: 230px;
      height: 100%;
      overflow-x: hidden;
      overflow-y: auto;
      .menu-title {
        text-align: left;
        color: #eff4ff;
        line-height: 44px;
        padding-left: 16px;
        color: #e6ebf2;
        font-size: 14px;
        opacity: 0.6;
      }
      .menu-side-itme:nth-child(1) {
        border-bottom: 1px solid #172d4d;
      }
      .menu-side-itme:nth-child(2) {
        border-bottom: 1px solid #172d4d;
        padding-bottom: 16px;
        // margin-bottom: 16px;
      }

      ul {
        width: 250px;

        li {
          margin-bottom: 8px;
           &:hover {
              background: #3377ff;
            }
            &.active {
              background: #3377ff;
            }

          .side-item {
            display: block;
            height: 56px;
            text-align: left;
            color: #eff4ff;
            line-height: 56px;
            padding-left: 16px;
            cursor: pointer;
            display: flex;
            align-items: center;


            i.side-icon {
              display: inline-block;
              width: 24px;
              height: 24px;
              margin-right: 5px;
              svg {
                width: 24px;
                height: 24px;
                font-size: 24px;
                vertical-align: top;
                fill: #eff4ff !important;
              }
            }

            span {
              font-size: 14px;
              line-height: 25px;
              vertical-align: middle;
            }
          }
        }
      }
    }
  }
  .yisu-admin-body {
    flex: 1;
    min-height: calc(100vh - 60px);
    box-sizing: border-box;
    padding: 24px 32px;
    overflow: auto;
  }
}
.account-wrap {
  margin: 0 -12px;
  .balance-action {
    padding: 16px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .balance-box {
      font-size: 24px;
    }
  }
  .catalog-list {
    ul {
      li {
        width: 100%;
        padding: 0 12px;
        line-height: 36px;
        cursor: pointer;
      }
      li:hover {
        background: #f7f9ff;
      }
    }
  }
}

.money-icon{
  width: 16px;
  height: 16px;
}
.money-icon svg {
  display: inline-block;
  width: 16px;
  height: 16px;
  font-size: 16px;
  margin-top: 4px;
  /*vertical-align: middle;*/
  cursor: pointer;
}


.yisu-admin-nav {
  display: none;
}

@media screen and (max-width: 768px) {
  .admin-main {
    width: 100%;
    height: calc(100% - 48px);
  }
  .yisu-admin-header {
    width: 100%;
    height: 48px;
    background: #0f1e33;
    box-shadow: 0px 2px 2px 0px rgba(77, 77, 77, 0.2);
    position: sticky;
    top: 0;
    z-index: 2000;
    .admin-logo {
      display: none;
    }
    .admin-header-tool {
      display: none;
    }

    .yisu-admin-nav {
      width: 100%;
      display: block;
      position: relative;
      .user-box {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 50%;
        left: 18px;
        transform: translateY(-50%);
        span {
          svg {
            width: 20px;
            height: 20px;
            font-size: 20px;
            fill: #fff;
          }
        }
      }
      .logo {
        height: 100%;
        padding: 0 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          display: inline-block;
          width: 22px;
          height: 17px;
          vertical-align: middle;
          margin-right: 4px;
        }
        span {
          color: #ffffff;
          font-size: 14px;
        }
      }
      .menubox {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 50%;
        right: 18px;
        transform: translateY(-50%);

        span {
          display: inline-block;
          width: 20px;
          height: 20px;
          svg {
            width: 20px;
            height: 20px;
            font-size: 20px;
            fill: #fff;
          }
        }
      }
    }
    .menubox-list {
      position: fixed;
      top: 48px;
      left: 0;
      right: 0;
      bottom: 0;
      background: #fff;
      z-index: 1002;
      ul {
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto;
        padding-top: 20px;
        li {
          color: #0f1e33;
          font-size: 16px;
          font-weight: 500;
          color: #0f1e33;
          padding: 15px 0 15px;

          .side-icon {
            display: inline-block;
            width: 24px;
            height: 24px;
            font-size: 24px;
            margin: 0 16px 0 24px;
            vertical-align: middle;
            svg {
              width: 24px;
              height: 24px;
              font-size: 24px;
              fill: rgb(165, 164, 164) !important;
            }
          }
          > span {
            display: inline-block;
            line-height: 24px;
            vertical-align: middle;
          }
        }
        li.active {
          background: rgb(208, 222, 252);
        }
      }
    }
  }
  .admin-main .yisu-admin-side {
    display: none;
  }
  .admin-main .yisu-admin-body{
    padding: 24px 16px;
  }
}
</style>
<style lang="scss">

.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border: none;
}
.language-box {
  min-width: 100px;
  .el-input__inner {
    width: 100px;
    white-space: normal;
    border: none;
    padding-left: 0;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue